import { render, staticRenderFns } from "./InternetBank.vue?vue&type=template&id=503cca7c&scoped=true"
import script from "./InternetBank.vue?vue&type=script&lang=js"
export * from "./InternetBank.vue?vue&type=script&lang=js"
import style0 from "./InternetBank.vue?vue&type=style&index=0&id=503cca7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503cca7c",
  null
  
)

export default component.exports